// extracted by mini-css-extract-plugin
export var askAiIcon = "_np-9";
export var container = "_np-0";
export var groupSeparator = "_np-a";
export var highlight = "_np-4";
export var resultIcon = "_np-5";
export var resultItem = "_np-7";
export var resultSubtitle = "_np-3";
export var resultTitle = "_np-2";
export var resultsList = "_np-1";
export var searchGroup = "_np-6";
export var selected = "_np-8";